<template>
  <div>
    <b-card border-variant="light" class="custom-card">
      <b-form id="alter-form" class="alter-form">
        <b-form-row>
          <b-col> FUNCIONALIDADE </b-col>
          <b-col>
            <b-form-select
              v-model.lazy.trim="form.code"
              :options="typesOptions"
              :state="validateField('code')"
              v-on:change="onChangeType(form.code)"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> LINK </b-col>
          <b-col>
            <CustomLinkEdit
              :state="validateLink('description')"
              class="w-100"
              :value="form.description"
              :onActionEdit="onActionEdit"
              :onChangedValue="onChangedValue"
              :onlyRead="!editable"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> HISTÓRICO </b-col>
          <b-col>
            <p class="text-invalid-right">{{ form.updateBy }}</p>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
    <b-button
      v-if="editable"
      :disabled="loading"
      type="button"
      class="mt-3"
      variant="primary"
      @click="onSubmit"
    >
      Salvar
      <i class="fas fa-spinner fa-spin icon" v-show="this.loading"></i>
    </b-button>
    <success-modal
      ref="success-modal"
      description="Alteraçao salva com sucesso!"
      buttonText="Ok, entendi!"
    />
  </div>
</template>
<script>
import { inject } from "@vue/composition-api";
import {
  validateField,
  validateLink,
  validateFieldEndDate,
  validateFieldStartDate,
  requiredFieldsFilled,
} from "../../../utils/validate/validate.js";
import LinkTypesOptions from "../../../static-data/ServiceTypesLinks.js";
import {
  getLinkByType,
  updateLink,
} from "../../../services/external-link-management/external-link-management.js";
import { createToast } from "../../../components/toast/toast.js";
import SuccessModal from "../../../components/base-modals/SuccessModal.vue";
import CustomLinkEdit from "../../../components/custom-link/CustomLinkEdit.vue";

const DefaultForm = {
  id: null,
  code: null,
  description: "",
  updateBy: "",
};

export default {
  name: "external-link-management-form-view",
  props: ["onChangeTab", "index"],
  components: {
    SuccessModal,
    CustomLinkEdit,
  },
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  async mounted() {
    this.initForm();
  },
  data() {
    return {
      form: { ...DefaultForm },
      formSubmited: false,
      validations: {},
      typesOptions: [],
      loading: false,
      buttonVisible: false,
      validateField,
      validateLink,
      validateFieldStartDate,
      validateFieldEndDate,
      requiredFieldsFilled,
      editable: false,
    };
  },
  methods: {
    initForm() {
      this.form = { ...DefaultForm };
      this.initType();
    },
    onActionEdit(value) {
      this.editable = !value;
      if (!this.editable) this.onChangeType(this.form.code);
    },
    onChangedValue(link) {
      this.form = { ...this.form, description: link };
    },
    validateForm() {
      return this.requiredFieldsFilled();
    },
    async onSubmit() {
      this.formSubmited = true;
      var canSubmit = this.validateForm();

      if (canSubmit) {
        this.loading = true;

        try {
          const resp = await updateLink(this.form);
          this.form = { ...resp };
          this.editable = false;
          const modal = this.$refs["success-modal"].$children[0];
          modal.show();
          this.initForm();
        } catch (e) {
          console.error("onSubmit", e);
          createToast("Atenção", "Ocorreu um erro atualizar o link.");
        } finally {
          this.formSubmited = false;
          this.loading = false;
        }
      }
    },
    async onChangeType(type) {
      this.form.type = type;
      const resp = await getLinkByType(type);
      this.editable = false;
      this.form = { ...resp };
    },
    async initType() {
      this.typesOptions = this.buildSelectTypeOptions(LinkTypesOptions);
    },
    buildSelectTypeOptions(dataOptions) {
      return [
        { value: null, text: "Selecione uma funcionalidade", disabled: true },
        ...dataOptions
          .filter((item) => item.visibled == true)
          .map((formData) => ({
            value: formData.value,
            text: formData.text,
          })),
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.align-right-all-time {
  position: absolute;
  right: 4px;
}
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.b-form-tag > button.b-form-tag-remove {
  font-size: 180%;
}
.text-invalid-right {
  width: 100%;
  text-align: right;
  color: var(--dark-0) !important;
  font-size: 1rem !important;
}
.custom-align {
  margin-right: 1rem;
}
</style>
